import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './ui/Reveal';
import { UPLOADS_URL } from '../api/axios';

const resolveImg = (src, fallback = '') => {
  if (!src) return fallback;
  if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('/')) return src;
  return `${UPLOADS_URL}/${src}`;
};

const HeroBanner = ({
  title,
  subtitle,
  breadcrumb = '',
  breadcrumbs = [],
  image,
  fallback = '/images/page-banners/why-choose-us.jpg',
  alt = '',
  loading = false,
}) => {
  const imgSrc = resolveImg(image, fallback);

  // Derive breadcrumb label if not provided
  let breadcrumbLabel = breadcrumb;
  if (!breadcrumbLabel && breadcrumbs && breadcrumbs.length > 0) {
    const last = breadcrumbs[breadcrumbs.length - 1];
    breadcrumbLabel = typeof last === 'string' ? last : (last.label || '');
  }
  if (!breadcrumbLabel && title) {
    breadcrumbLabel = title;
  }
  const cleanBreadcrumb = String(breadcrumbLabel || 'PAGE').toUpperCase();

  return (
    <section className="hero-banner relative w-full h-[200px] sm:h-[280px] md:h-[360px] lg:h-[440px] overflow-hidden bg-[#0c1a30]">
      <img
        src={imgSrc}
        alt={alt || title || 'Hero Banner'}
        className="w-full h-full object-fill object-center"
        loading="eager"
        onError={(e) => {
          if (fallback && !e.target.dataset.triedFallback) {
            e.target.dataset.triedFallback = 'true';
            e.target.src = fallback;
          }
        }}
      />

      {/* Dark Vignette / Gradient Overlay */}
      <div
        className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/25"
        aria-hidden="true"
      />

      {/* Bottom-Centered Text Container */}
      <div className="absolute inset-0 flex flex-col justify-end items-center text-center pb-4 sm:pb-7 md:pb-9 lg:pb-11 px-4 z-10">
        <Reveal className="w-full max-w-4xl mx-auto flex flex-col items-center text-center">
          {title && (
            <h1 className="text-white font-serif font-normal text-xl sm:text-3xl md:text-4xl lg:text-[44px] leading-tight tracking-wide drop-shadow-md max-w-4xl mx-auto text-center">
              {title}
            </h1>
          )}

          {subtitle && (
            <p className="text-white/95 text-[11px] sm:text-xs md:text-base font-normal mt-1 sm:mt-2 md:mt-2.5 max-w-2xl mx-auto drop-shadow line-clamp-2 text-center !text-center">
              {subtitle}
            </p>
          )}

          <div className="inline-flex items-center justify-center gap-1.5 text-[10px] sm:text-xs font-bold uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[#d8a85f] mt-2 sm:mt-3 md:mt-4">
            <Link to="/" className="text-white/80 hover:text-white transition-colors">
              HOME
            </Link>
            <span className="text-white/40">&rsaquo;</span>
            <span className="text-white tracking-widest font-extrabold">
              {cleanBreadcrumb}
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default HeroBanner;
